import type { FC } from 'react';
import { IconButton } from 'react-native-paper';

import { MyLocationIcon } from '@/assets';
import { LocationGuard } from '@/shared/components/location/LocationGuard';
import { OutlinedButton } from '@/shared/components/OutlinedButton';

type CurrentLocationButtonProps = {
  iconOnly?: boolean;
  onPress: () => void;
  label?: string;
};
export const CurrentLocationButton: FC<CurrentLocationButtonProps> = ({
  onPress,
  label,
  iconOnly = false
}) => (
  <LocationGuard>
    {iconOnly ? (
      <IconButton
        icon={({ color, size }) => (
          <MyLocationIcon fill={color} width={size} height={size} />
        )}
        onPress={onPress}
      />
    ) : (
      <OutlinedButton
        contentStyle={{ height: 32 }}
        labelStyle={{ marginVertical: 'auto' }}
        onPress={onPress}
        icon={({ color, size }) => (
          <MyLocationIcon fill={color} width={size} height={size} />
        )}
      >
        {label}
      </OutlinedButton>
    )}
  </LocationGuard>
);
